module.exports = __webpack_public_path__ + "static/three-ce0c50dfa920df1c3cadbeee721ee02d.png";